import { LAYOUT } from '@/router/constant';
import { AppRouteModule } from '@/router/types';
import { PageEnum } from '@/enums/pageEnum';
import { t } from '@/hooks/web/useI18n';

const setting: AppRouteModule = {
    path: '/setting',
    name: 'Setting',
    component: LAYOUT,
    redirect: '/setting/index',
    meta: {
        orderNo: 13,
        icon: 'setting',
        title: t('routes.index.setting.setting'),
    },
    children: [
        {
            path: 'index',
            name: PageEnum.SETTING,
            component: () => import('@/views/menu/setting/setting.vue'),
            meta: {
                title: t('routes.index.setting.index'),
            },
        },
    ],
};

export default setting;
